import { action, makeAutoObservable, observable } from "mobx";
import { loadDataHelper } from "./storeHelpers";
import { StoreBaseMethods } from "./storeBase";
import Agent from "env/agent";

class FilesStore  {
  host = null
  constructor({ data, host, authTokens } = {}) {
    makeAutoObservable(this, undefined, {autoBind: true});
    StoreBaseMethods.copyData(data, this);

    this.authTokens = authTokens;
    this.host = host || data?.host;
  }

  get agent() {
    return new Agent(this.host, this.authTokens);
  }
  @observable isLoadingMyFiles = false;
  @observable hasLoadedMyFiles = false;
  @observable myFiles = [];
  @action loadMyFiles() {
    return loadDataHelper({
      store: this,
      agentKey: 'Files',
      key: 'MyFiles',
    });
  }

  @action loadFile(file_id) {
    return this.agent
    .Files
    .getFile(file_id);
  }
}
export default FilesStore;
